// VFX: Datamosh Glitch Transition
// Category: overlays · Tags: datamosh, glitch, transition, codec, music-video
// Pixel datamosh compression artifact — corrupted video codec effect.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, random, interpolate } from "remotion";
import React from "react";

export default function FxGlitchDatamosh600Ms() {
  const frame = useCurrentFrame();
  const { width, height, durationInFrames } = useVideoConfig();
  const intensity = interpolate(frame, [0, durationInFrames * 0.4, durationInFrames], [1, 0.6, 0], { extrapolateRight: "clamp" });
  const sliceCount = 14;

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(135deg, #a855f7 0%, #06b6d4 50%, #f97316 100%)",
      overflow: "hidden",
    }}>
      {/* Underlying "image" gradient layers */}
      <AbsoluteFill style={{
        background: "radial-gradient(circle at 30% 40%, #ef4444 0%, transparent 50%), radial-gradient(circle at 70% 60%, #10b981 0%, transparent 50%)",
        opacity: 0.6,
      }} />

      {/* Macroblock corruption */}
      {Array.from({ length: 60 }).map((_, i) => {
        const t = Math.floor(frame / 3);
        const x = random(`x-${i}-${t}`) * width;
        const y = random(`y-${i}-${t}`) * height;
        const w = 40 + random(`w-${i}-${t}`) * 120;
        const h = 30 + random(`h-${i}-${t}`) * 80;
        const hue = (random(`c-${i}-${t}`) * 360) | 0;
        return (
          <div key={i} style={{
            position: "absolute", left: x, top: y, width: w, height: h,
            background: `hsl(${hue},80%,60%)`,
            opacity: intensity * 0.6,
            mixBlendMode: "screen",
          }} />
        );
      })}

      {/* Horizontal slice tears */}
      {Array.from({ length: sliceCount }).map((_, i) => {
        const sy = (i / sliceCount) * height;
        const sh = height / sliceCount;
        const dx = (random(`dx-${i}-${Math.floor(frame / 2)}`) - 0.5) * 200 * intensity;
        const hueShift = (random(`hs-${i}-${frame}`) - 0.5) * 360;
        return (
          <div key={`s-${i}`} style={{
            position: "absolute", left: dx, top: sy, width, height: sh,
            background: `linear-gradient(90deg, hsl(${hueShift},80%,60%) 0%, transparent 100%)`,
            mixBlendMode: "difference",
            opacity: 0.4 * intensity,
          }} />
        );
      })}

      {/* RGB channel split */}
      <div style={{
        position: "absolute", inset: 0,
        background: "rgba(239,68,68,0.18)", mixBlendMode: "screen",
        transform: `translateX(${intensity * 12}px)`,
      }} />
      <div style={{
        position: "absolute", inset: 0,
        background: "rgba(6,182,212,0.18)", mixBlendMode: "screen",
        transform: `translateX(${-intensity * 12}px)`,
      }} />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
